// eslint-disable-next-line import/prefer-default-export
export const LLM = 'llm';

export const LLM_DEFAULT_SESSION = 'llm-default-session';

export const DATA_CHANNEL_WITH_JWT_TOKEN = 'data-channel-with-jwt-token';

export const SUBSCRIPTION_AWARE_SUBCHANNELS_PARAM = 'subscriptionAwareSubchannels';

export const DATA_CHNANEL_TYPE = {
  TRANSCRIPTION: 'transcription',
};

export const AWARE_DATA_CHANNEL = [DATA_CHNANEL_TYPE.TRANSCRIPTION];
